export const defaultContainerWidth = 1060
export const defaultContainerHorizontalPadding = 40
export const defaultContainerMobileHorizontalPadding = 20
export const defaultContainerVerticalPadding = 100
export const defaultContainerMaxWidth =
  defaultContainerWidth + defaultContainerHorizontalPadding * 2
export const mediaQuerySmall = '@media screen and (max-width: 40rem)'
export const mediaQueryMedium = '@media screen and (max-width: 68rem)'

// Container-query counterparts of the media queries above — for components that
// adapt to their own container width (e.g. placed in a narrow column) rather
// than the viewport. Requires an ancestor with `container-type: inline-size`.
export const containerQuerySmall = '@container (max-width: 34rem)'
export const containerQueryMedium = '@container (max-width: 56rem)'
